// @flow
import styled from 'styled-components';

import colors from '../../assets/css/colors';
import { above } from '../../assets/css/media';

export const PageSubTitle = styled.h2`
	color: ${colors.darkGrey};
	font-size: 15px;
	font-weight: bold;
	line-height: 1.3;

	margin: 20px 10px 12px;

	${above.phone`
		font-size: 16px;
	`}

	${above.tablet`
		font-size: 18px;
		margin: 24px 0 16px;
	`}
`;

export default PageSubTitle;


// WEBPACK FOOTER //
// ./src/components/PageSubTitle/index.js